import styled from "@emotion/styled";
import { allNewsCategory } from "admin/type/type";
import Chip from "component/chips/Chip";
import React from "react";

interface Props {
  selectedCategories: string[];
  onSelect: (categoryName: string) => void;
  onSelectAll: () => void;
}
const NewsCategoryList: React.FC<Props> = (props) => {
  const isAllSelect = props.selectedCategories.length === 0;

  return (
    <Container>
      <div className="category__list__container">
        <span className={`font-sub-title4`}>CATEGORY</span>
        <div className="category__list">
          <Chip
            isClickable
            isActive={isAllSelect}
            onClickChip={props.onSelectAll}
          >
            All
          </Chip>

          {allNewsCategory.map((item) => {
            return (
              <Chip
                key={item.id}
                isClickable
                isActive={props.selectedCategories.includes(item.name)}
                onClickChip={() => {
                  props.onSelect(item.name);
                }}
              >
                {item.displayName || item.name}
              </Chip>
            );
          })}
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;

  .category__list__container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 56px;
    gap: 24px;
    .category__list {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
    }
  }

  @media only screen and (max-width: 768px) {
    .category__list__container {
      flex-direction: column;
      align-items: flex-start;
      margin-top: 40px;
      gap: 16px;
    }
  }
`;

export default NewsCategoryList;
